module.exports = __webpack_public_path__ + "assets/img/33_715_big.48c6b390.jpg";